/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./../components/header.css";
import { Dropdown, Menu } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useCart } from "../context/CartContext";
// import { IoFastFoodOutline } from "react-icons/io5";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { cartCount, setCartCount } = useCart();
  const menuRef = useRef(null);

  // Sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close nav-menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
     localStorage.clear();
      setCartCount(0);
      navigate("/");
    } else if (key === "account") {
      navigate("/my-account");
    }
  };

  const token = localStorage.getItem("token");

  const menu = (
    <Menu onClick={handleMenuClick}>
      {token ? (
        <>
          {/* <Menu.Item key="account" icon={<UserOutlined />}>
            My Account
          </Menu.Item>
          <Menu.Item key="my-order" icon={<IoFastFoodOutline />}>
            <Link to="/my-order">Past Order</Link>
          </Menu.Item> */}
          <Menu.Item key="logout" danger icon={<LogoutOutlined />}>
            Logout
          </Menu.Item>
        </>
      ) : (
        <Menu.Item key="login" icon={<UserOutlined />}>
          <Link to="/login">Login</Link>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <header
      className={`main-header ${
        location.pathname === "/" ? "absolute-header" : "other-page-header"
      } ${isSticky ? "sticky-header" : ""}`}
    >
      <div className="nav-rounded-box">
        <div className="logo-rounded">
          <Link to="/">
            <img src="/Images/new-logo-main.png" alt="Far Boy Cafe" loading="lazy"/>
          </Link>
        </div>

        <div className="menu-cart-wrapper">
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>

        
            <div
              className="cart-toggle"
              onClick={() => {
                setMenuOpen(false);
                navigate("/my-cart");
              }}
            >
              <img
                src="/Images/mobile-cart.svg"
                alt="cart"
                className="cart-icon-img"
                loading="lazy"
              />
              {cartCount > 0 && (
                <span className="cart-count-badge">{cartCount}</span>
              )}
            </div>
          
        </div>

        <nav className="nav-menu" ref={menuRef}>
          <ul className={menuOpen ? "open" : ""}>
            <li>
              <Link
                to="/"
                className={location.pathname === "/" ? "active" : ""}
                onClick={() => setMenuOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link to="/about-mandurah-cafe" onClick={() => setMenuOpen(false)}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/view-our-menu" onClick={() => setMenuOpen(false)}>
                Menu
              </Link>
            </li>
            <li>
              <Link to="/informative-blog" onClick={() => setMenuOpen(false)}>
                Blogs
              </Link>
            </li>
            <li>
              <Link to="/contact-us" onClick={() => setMenuOpen(false)}>
                Contact Us
              </Link>
            </li>

            <div className="header-icon">
              <li className="cart-mobile">
                <div
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/my-cart");
                  }}
                  className="icon-wrap"
                  style={{ cursor: "pointer" }}
                >
                  <a className="hide-on-desktop cart-mobile">Cart</a>
                  <img
                    src="/Images/grocery-store.svg"
                    alt="cart"
                    className="cart-image hide-on-mobile"
                    loading="lazy"
                  />
                  {cartCount > 0 && (
                    <span className="cart-count-badge cart-mobile">
                      {cartCount}
                    </span>
                  )}
                </div>
              </li>
              <li>
                <Dropdown
                  overlay={menu}
                  placement="bottomRight"
                  trigger={["click"]}
                >
                  <div className="icon-wrap" style={{ cursor: "pointer" }}>
                    <a className="hide-on-desktop">
                      {token ? "My Profile" : "Register"}
                    </a>
                    <img
                      src="/Images/cafe-user.svg"
                      alt="account"
                      className="cart-image hide-on-mobile"
                      loading="lazy"
                    />
                  </div>
                </Dropdown>
              </li>
            </div>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
